// extracted by mini-css-extract-plugin
export default {"container":"EventsPage_container__3XQwB","search-container":"EventsPage_search-container__7xtzc"};